'use client'

import { warnIfEmptyLabel } from '@/utils'

export interface LoadingProps {
  /**
   * Visible loading message. Required — provide a localized string from the
   * consuming app (there is no default).
   */
  text: string
}

export function Loading({ text }: LoadingProps) {
  warnIfEmptyLabel(text, 'Loading: text')

  return (
    <div
      className="fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-white bg-opacity-90 text-gray-500"
      data-testid="loading"
    >
      <div className="flex flex-col items-center justify-center gap-6">
        <span className="font-medium">{text}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="74"
          height="53"
          fill="none"
          data-testid="loading-svg"
        >
          <path
            fill="#EB2FAB"
            d="M11.52 24H1.592C.713 24 0 24.748 0 25.67v18.66C0 45.251.713 46 1.592 46h9.928C17.308 46 22 41.075 22 35s-4.692-11-10.48-11Zm3.837 12.287c-.733 0-1.326-.623-1.326-1.392 0-.77.593-1.392 1.326-1.392.732 0 1.326.623 1.326 1.392 0 .769-.594 1.392-1.326 1.392Z"
            className="animate-move [animation-delay:0.2s]"
          />
          <path
            fill="#35ACE8"
            d="M37.52 10h-9.928c-.879 0-1.592.782-1.592 1.747v19.506c0 .965.713 1.747 1.592 1.747h9.928C43.308 33 48 27.851 48 21.5S43.308 10 37.52 10Zm3.837 12.845c-.733 0-1.326-.651-1.326-1.455s.593-1.455 1.326-1.455c.732 0 1.326.651 1.326 1.455s-.594 1.455-1.326 1.455Z"
            className="animate-move [animation-delay:0.5s]"
          />
          <path
            fill="#F2AA1A"
            d="M63.52 31h-9.928c-.879 0-1.592.748-1.592 1.67v18.66c0 .922.713 1.67 1.592 1.67h9.928C69.308 53 74 48.075 74 42s-4.692-11-10.48-11Zm3.837 12.287c-.733 0-1.326-.623-1.326-1.392 0-.77.593-1.392 1.326-1.392.732 0 1.326.623 1.326 1.392 0 .769-.594 1.392-1.326 1.392Z"
            className="animate-move [animation-delay:0.8s]"
          />
        </svg>
      </div>
    </div>
  )
}
